import { FormikErrors, FormikTouched } from "formik";
import React, { FC, useMemo } from "react";
import "./ErrorNotification.scss";
const ErrorNotification: FC<{
  errors: FormikErrors<{}>;
  isTouched: FormikTouched<{}>;
  arrayKey?: string;
  secondArrayKey?: string;
}> = ({ errors, isTouched, arrayKey, secondArrayKey }) => {
  const getErrorsData = (
    errors: FormikErrors<{}>,
    touched: FormikTouched<{}>,
    arrayKey?: string,
    secondArrayKey?: string
  ) => {
    const errorsArray: { errorMessage: string; isTouched: boolean }[] = [];
    Object.keys(errors).forEach((key) => {
      if (!errorsArray.find((e) => e.errorMessage === errors[key])) {
        errorsArray.push({
          errorMessage: errors[key],
          isTouched: key.includes(".")
            ? (touched[arrayKey!] &&
                touched[arrayKey!][0][key.split(".")[2]]) ??
              (touched[secondArrayKey!] &&
                touched[secondArrayKey!][0][key.split(".")[2]])
            : touched[key],
        });
      }
    });
    return errorsArray;
  };

  const getErrorsMessages = useMemo(() => {
    const errorMessages = getErrorsData(
      errors,
      isTouched,
      arrayKey,
      secondArrayKey
    );

    return errorMessages.filter((error) => error.isTouched);
  }, [errors, isTouched, arrayKey, secondArrayKey]);

  return (
    <>
      {getErrorsMessages.length > 0 && (
        <div className="error-notification">
          <ul>
            {getErrorsMessages.map((errors) => {
              return <li key={errors.errorMessage}>{errors.errorMessage}</li>;
            })}
          </ul>
        </div>
      )}
    </>
  );
};

export default ErrorNotification;
